<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="VendorName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
          <template #col-name="{ row }">
            <vs-chip :color="row.color">
                {{ $t(row.name) | capitalize }}
            </vs-chip>
        </template>
        <template #col-rps_active="{ row }">
            <vs-switch color="success" v-model="row.rps_active"  @input="updateVendor('rps_active',row.rps_active,row.VendorId)"/>
        </template>
        <template #col-rps_blacklist="{ row }">
            <vs-switch color="danger" v-model="row.rps_blacklist" @input="updateVendor('rps_blacklist',row.rps_blacklist,row.VendorId)" />
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'

const emit = defineEmits(['sortChanged', 'loadMore','updateVendor','details'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'VendorName', label: 'name', sortable: true },
    { key: 'RFC', label: 'RFC', sortable: true },
    { key: 'name', label: 'status', sortable: true },
    { key: 'rps_active', label: 'active', sortable: false },
    { key: 'rps_blacklist', label: 'blacklist', sortable: false }
])

const actionButtons = ref([
    { text: 'details', icon: 'ArrowRightCircleIcon', color: 'primary', permissions:['IU Repse'], onClick: row => emit('details', row) }
])

const updateVendor = (field,value,id) => {
    const data = { field, value, id}
    emit('updateVendor',data)
}

</script>
